import { Component, OnInit } from "@angular/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

@Component({
    selector: "app-thumb-animation",
    templateUrl: "./thumb-animation.component.html",
    styleUrls: ["./thumb-animation.component.scss"],
    standalone: true,
    imports: [LottieComponent],
})
export class ThumbAnimationComponent {
  options: AnimationOptions = {
    path: "https://assets10.lottiefiles.com/packages/lf20_xsgxu8if.json",
  };
  constructor() {}
  onLoopComplete() {}
}
